import * as React from 'react';

export function Location(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 20 20" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.1131 8.94172C14.7095 7.17182 15 5.92789 15 5.37501C15 2.97472 12.7795 1 10 1C7.22049 1 5 2.97472 5 5.37501C5 5.96585 5.25871 7.2419 5.78134 8.99669C6.28442 10.6858 6.97778 12.6451 7.72726 14.5064C8.4099 16.2016 9.12379 17.7774 9.7653 18.9758L9.8431 19C10.4768 17.7695 11.2267 16.1691 11.9602 14.469C12.7685 12.5955 13.5435 10.6316 14.1131 8.94172ZM12 4.54731C12 5.52687 11.1046 6.32096 10 6.32096C8.89543 6.32096 8 5.52687 8 4.54731C8 3.56774 8.89543 2.77365 10 2.77365C11.1046 2.77365 12 3.56774 12 4.54731Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default Location;
